import * as React from 'react';
import Constants from 'src/support/Constants';

const CartSummary = (props) => {
    return (
        <>
            {props.summaryFor === Constants.cartSummary.SUBTOTAL &&
                <div className="col-12">
                    <div className="bs5 row m-0 mini-cart-item-total">
                        <div className="col-7 px-0">
                            <span>
                                <span className="cart-item-count">({props.itemLength}){" "}</span>
                                Items Subtotal:
                            </span>
                        </div>
                        <div className="col-5 text-end font_bold_currency ps-1">
                            <span className="font_bold_currency">
                                {/* //{isNumber(props.subTotal) ? Helper.getFormatNumber(Number(props.subTotal)) : ""} */}
                                {props.subTotal}
                            </span>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default CartSummary;